import axios from 'axios';

// Configuration axios par défaut
axios.defaults.withCredentials = true;
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';

export const  getMappings = async () => {
  try {
    const url = `${process.env.REACT_APP_VISION_API}/mappings/admin.php`;

    const response = await axios.post(url, {
      categoryId: 0,
      visionResults: {
        labelAnnotations: []
      }
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des mappings:', error);
    console.error('Configuration de la requête:', error.config);
    throw error;
  }
};

export const sendResultsToMappingAPI = async (results, visionResults) => {
  const url = 'http://localhost/apivision/mappings/admin.php';
  const data = {
    categoryId: results.categoryId,
    visionResults
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      credentials: 'include',
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData = await response.json();
    return responseData;

  } catch (error) {
    console.error('Erreur détaillée !!!!:', {
      message: error.message,
      name: error.name,
      stack: error.stack
    });

    // Vérifier si le serveur est accessible
    try {
      const testResponse = await fetch(url, { 
        method: 'HEAD',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
    } catch (testError) {
      console.error('Le serveur n\'est pas accessible:', testError);
    }

    throw error;
  }
}; 